<template>
  <div class="forgot-password-page">
    <!-- 左侧背景图 -->
    <div class="forgot-password-left"></div>

    <!-- 右侧找回密码框 -->
    <div class="forgot-password-right">
      <el-card class="forgot-password-card">
        <h2 class="forgot-password-title">找回密码</h2>
        <el-form :model="forgotPasswordForm"
                 :rules="rules"
                 ref="forgotPasswordForm"
                 label-width="80px">
          <!-- 邮箱输入框 -->
          <el-form-item label="邮箱"
                        prop="email">
            <el-input v-model="forgotPasswordForm.email"
                      placeholder="请输入邮箱"></el-input>
          </el-form-item>

          <!-- 邮箱验证码输入框 -->
          <el-form-item label="验证码"
                        prop="emailCode">
            <el-input v-model="forgotPasswordForm.emailCode"
                      placeholder="请输入邮箱验证码"></el-input>
          </el-form-item>

          <!-- 新密码输入框 -->
          <el-form-item label="新密码"
                        prop="newPassword">
            <el-input v-model="forgotPasswordForm.newPassword"
                      type="password"
                      placeholder="请输入新密码"></el-input>
          </el-form-item>

          <!-- 确认密码输入框 -->
          <el-form-item label="确认密码"
                        prop="confirmPassword">
            <el-input v-model="forgotPasswordForm.confirmPassword"
                      type="password"
                      placeholder="请再次输入新密码"></el-input>
          </el-form-item>

          <!-- 确认修改按钮 -->
          <el-form-item class="forgot-password-button-center">
            <el-button type="primary"
                       @click="onSubmit">确认修改</el-button>
          </el-form-item>
					<div class="login-footer">
            <el-link @click="onBack">返回登录</el-link>
          </div>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      forgotPasswordForm: {
        email: '',
        emailCode: '',
        newPassword: '',
        confirmPassword: ''
      },
      rules: {
        // 邮箱验证
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '邮箱格式不正确', trigger: 'blur' }
        ],
        // 邮箱验证码验证
        emailCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        // 新密码验证
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '密码长度至少6个字符', trigger: 'blur' }
        ],
        // 确认密码验证
        confirmPassword: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { validator: (rule, value, callback) => {
            if (value !== this.forgotPasswordForm.newPassword) {
              callback(new Error('两次密码输入不一致'));
            } else {
              callback();
            }
          }, trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    onSubmit () {
      this.$refs.forgotPasswordForm.validate((valid) => {
        if (valid) {
          // 模拟密码修改成功
          this.$message.success('密码修改成功');
          setTimeout(() => {
            this.$router.push('/login'); // 修改成功后跳转到登录页面
          }, 2000);
        } else {
          console.log('找回密码表单验证失败');
        }
      });
    },
		onBack () {
      this.$router.push('/login'); // 返回登录页面
    }
  }
};
</script>

<style scoped>
.forgot-password-page {
  display: flex;
  height: 100vh;
  background-image: url('/image/login.jpg'); /* 背景图片 */
  background-size: cover;
  background-position: center;
}

.forgot-password-left {
  flex: 1;
  background-size: cover;
  background-position: center;
}

.forgot-password-right {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.forgot-password-card {
  width: 100%;
  max-width: 400px;
}

.forgot-password-title {
  text-align: center;
  margin-bottom: 20px;
}

.forgot-password-button-center {
  text-align: center;
  width: 100%;
}
.forgot-password-button-center button {
  width: 50%; 
  margin-left: -70px;
}
.login-footer {
  display: flex;
  justify-content: space-between;
}
</style>
